import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const ChargeTransactionPayloadSchema = z
    .object({
        note: z.string().max(250),
        payoutId: z.string().optional(),
    })
    .strict();

export class ChargeTransactionPayload extends FromSchema(ChargeTransactionPayloadSchema) {
    note: string;
    payoutId?: string;
}
